import {FavoriteDoctorsParams, FavoriteDoctorsResponse} from 'domain/usecases';
import {makeGetFavoriteDoctors} from 'main/factories/usecases';

export async function getFavoriteDoctors(
	params: FavoriteDoctorsParams,
): Promise<FavoriteDoctorsResponse> {
	return makeGetFavoriteDoctors().get(params);
}
